import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, of } from 'rxjs';
import { CommonService } from "../../services/common-service";
import { CnpjPipe } from "../../pipes/cnpj.pipe";

@Injectable({
    providedIn: 'root'
})
export class SelectPesquisavelService extends CommonService {

    constructor(private httpClient: HttpClient) {
        super();
    }

    /**
     * Busca os valores para o select.
     * @param uri A URL da API.
     * @param searchText O texto para filtrar. Se for vazio, nenhum filtro é aplicado.
     */
    public getSelectValues<T>(uri: string, searchText: string): Observable<T[]> {
        const httpOptions: { params?: HttpParams, headers?: any } = {
            headers: this.addHeaderToken().headers
        };

        if (searchText) {
            httpOptions.params = new HttpParams().set('textoBusca', searchText);
        }

        // A API retorna um objeto { list: [...] }, e não um array direto.
        // Usamos .pipe(map(...)) para extrair o array de dentro da resposta.
        return this.httpClient.get<{ list: T[] }>(uri, httpOptions).pipe(
            map(response => {
                const items = response.list || [];
                // Verifica se é uma lista de EmpresaGrupo e adiciona CNPJ formatado
                return items.map((item: any) => {
                    if (item && item.empresaPrincipal && item.empresaPrincipal.cnpj) {
                        return {
                            ...item,
                            cnpjFormatado: `Matriz: ${this.formatCNPJ(item.empresaPrincipal.cnpj)}`,
                            // CNPJ sem formatação para busca — preserva letras (CNPJ alfanumérico)
                            cnpjLimpo: item.empresaPrincipal.cnpj.toString().replace(/[.\-\/\s]/g, '')
                        };
                    }
                    return item;
                });
            }),
            catchError((err) => {
                this.handleError(err); // Continua usando seu manipulador de erro padrão
                return of([]); // Retorna um array vazio em caso de erro para não quebrar o select
            })
        );
    }

    /**
     * Formata CNPJ para exibição (delega para o pipe compartilhado, que já suporta CNPJ alfanumérico)
     */
    private formatCNPJ(cnpj: string): string {
        return new CnpjPipe().transform(cnpj) ?? '';
    }
}
